import { render } from "./HrLeave.vue?vue&type=template&id=838c3cc6&scoped=true"
import script from "./HrLeave.vue?vue&type=script&lang=js"
export * from "./HrLeave.vue?vue&type=script&lang=js"

import "./HrLeave.vue?vue&type=style&index=0&id=838c3cc6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-838c3cc6"]])

export default __exports__